import { inject } from 'mobx-react';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import {
  defineMessages,
  FormattedMessage,
  injectIntl,
  intlShape
} from 'react-intl';
import {
  Dropdown,
  DropdownMenu,
  DropdownToggle,
  DropdownItem
} from 'reactstrap';

import ProductSortOrderBy from '../../../types/ProductSortOrderBy';
import SortOrder from '../../../types/SortOrder';
import Icon from '../../common/Icon';
import { modelOf } from '../../../prop-types';
import ConfigStore from '../../../store/ConfigStore';
import ProductStore from '../../../store/ProductStore';

const sortNameMessages = defineMessages({
  sortDefault: {
    id: 'sort.default',
    defaultMessage: 'Default'
  },
  sortCheapest: {
    id: 'sort.cheapest',
    defaultMessage: 'Cheapest'
  },
  sortMostExpensive: {
    id: 'sort.mostExpensive',
    defaultMessage: 'Most expensive'
  },
  sortLatest: {
    id: 'sort.latest',
    defaultMessage: 'Latest'
  },
  sortMostPopular: {
    id: 'sort.mostPopular',
    defaultMessage: 'Most popular'
  },
  sortBestRated: {
    id: 'sort.bestRated',
    defaultMessage: 'Best rated'
  },
  sortBrand: {
    id: 'sort.brand',
    defaultMessage: 'Brand'
  },
  sortId: {
    id: 'sort.id',
    defaultMessage: 'Product number'
  },
  sortAlphabetical: {
    id: 'sort.alphabetical',
    defaultMessage: 'Alphabetical'
  },
  sortCategory: {
    id: 'sort.category',
    defaultMessage: 'Product category'
  },
  sortDiscount: {
    id: 'sort.discount',
    defaultMessage: 'Best discount'
  }
});

export class SortSelection extends Component {
  createSortSelection = (message, sortKey, sortOrder, sortIndex) => {
    return {
      message,
      sortKey,
      sortOrder,
      sortIndex
    };
  };

  constructor(props) {
    super(props);
    this.state = {
      open: false
    };

    this.sortSelections = [
      this.createSortSelection(sortNameMessages.sortDefault, null, null),
      this.createSortSelection(
        sortNameMessages.sortCheapest,
        ProductSortOrderBy.PRICE,
        SortOrder.ASC,
        1
      ),
      this.createSortSelection(
        sortNameMessages.sortMostExpensive,
        ProductSortOrderBy.PRICE,
        SortOrder.DESC,
        2
      ),
      this.createSortSelection(
        sortNameMessages.sortLatest,
        ProductSortOrderBy.DATE_ADDED,
        SortOrder.DESC,
        3
      ),
      this.createSortSelection(
        sortNameMessages.sortMostPopular,
        ProductSortOrderBy.SALES,
        SortOrder.DESC,
        4
      ),
      this.createSortSelection(
        sortNameMessages.sortBestRated,
        ProductSortOrderBy.REVIEWS_AVERAGE,
        SortOrder.DESC,
        5
      ),
      this.createSortSelection(
        sortNameMessages.sortBrand,
        ProductSortOrderBy.BRAND,
        SortOrder.ASC,
        6
      ),
      this.createSortSelection(
        sortNameMessages.sortId,
        ProductSortOrderBy.ID,
        SortOrder.ASC,
        7
      ),
      this.createSortSelection(
        sortNameMessages.sortAlphabetical,
        ProductSortOrderBy.NAME,
        SortOrder.ASC,
        8
      ),
      this.createSortSelection(
        sortNameMessages.sortCategory,
        ProductSortOrderBy.CATEGORY,
        SortOrder.ASC,
        9
      ),
      this.createSortSelection(
        sortNameMessages.sortDiscount,
        ProductSortOrderBy.DISCOUNT,
        SortOrder.DESC,
        10
      )
    ];

    this.filterActiveSortSelections();
  }

  filterActiveSortSelections = () => {
    const { productStore } = this.props;

    const activeProductSortSelectors = productStore.activeProductSortList();
    const activeSortSelections = this.sortSelections.filter((ss) =>
      activeProductSortSelectors.find((sort) => sort.sortIndex === ss.sortIndex)
    );

    if (!activeSortSelections.length) {
      return;
    }

    this.sortSelections = activeSortSelections.splice(
      0,
      0,
      this.sortSelections[0]
    );
    this.sortSelections = activeSortSelections;
  };

  getSelected = (sortKey, sortOrder) =>
    this.sortSelections.find(
      (ss) => ss.sortKey === sortKey && ss.sortOrder === sortOrder
    );

  toggleOpen = () => this.setState({ open: !this.state.open });

  render() {
    const { open } = this.state;
    const {
      onSelectSort,
      selectedSortKey,
      selectedSortOrder,
      intl
    } = this.props;
    const selectedValue = this.getSelected(selectedSortKey, selectedSortOrder);
    return (
      <div className="SortSelection">
        <FormattedMessage id="sort.sortLabel" defaultMessage="Sort:" />
        <Dropdown
          isOpen={open}
          toggle={this.toggleOpen}
          direction="down"
          className="SortSelection__dropdown"
        >
          <DropdownToggle
            data-toggle="dropdown"
            color="plain"
            aria-expanded={open}
            className="SortSelection__dropdown-toggle"
          >
            {selectedValue
              ? intl.formatMessage(selectedValue.message)
              : intl.formatMessage(this.sortSelections[0].message)}
            <Icon name="angle-down" className="SortSelection__toggle-icon" />
          </DropdownToggle>
          <DropdownMenu>
            {this.sortSelections.map((ss) => (
              <DropdownItem
                key={ss.sortKey + ss.sortOrder}
                onClick={() => onSelectSort(ss.sortKey, ss.sortOrder)}
                className="SortSelection__dropdown-item"
                active={ss === selectedValue}
              >
                {intl.formatMessage(ss.message)}
              </DropdownItem>
            ))}
          </DropdownMenu>
        </Dropdown>
      </div>
    );
  }
}

SortSelection.propTypes = {
  configStore: modelOf(ConfigStore).isRequired,
  productStore: modelOf(ProductStore).isRequired,
  selectedSortKey: PropTypes.string,
  selectedSortOrder: PropTypes.string,
  onSelectSort: PropTypes.func.isRequired,
  intl: intlShape.isRequired
};

export default injectIntl(inject('configStore', 'productStore')(SortSelection));



// WEBPACK FOOTER //
// ./src/components/product-list/SortSelection/index.jsx